<div style="padding:24px 32px 0">
    <app-host-base-info [item]="data"></app-host-base-info>
    <app-base-performace-chart [id]="data.actionParams" [performance]="[22,21,370]" type="HOST_TYPE" *ngIf="!FeatureConfig.IsHidePms"></app-base-performace-chart>
    <app-host-resource [data]="data"></app-host-resource>
</div>
